import React from 'react';
import styled from 'styled-components';
import { media } from 'helpers/MediaHelper';
import { colors } from 'helpers/ColorHelper';

const StyledCard = styled.div`
  color: ${colors.DARKEST_GRAY};
  border-radius: 20px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.125);
  text-align: left;
  padding: 24px 24px 16px 24px;
  background: #ffffff;

  ${media.mobile`
    padding: 16px;
  `};
`;

const Card = ({ children }) => {
  return <StyledCard>{children}</StyledCard>;
};

export default Card;
